<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Alarm.add")' :click='notices' eventType='add'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Alarm.remove")' :click='notices' eventType='remove'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Alarm.edit")' :click='notices' eventType='edit'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='notices' eventType='refresh'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("Alarm.able")' :click='notices' eventType='able'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Alarm.disable")' :click='notices' eventType='disable'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>
<script>
export default {
  name: 'idelTimeIndicatorThresholdTableButton',
  data() {
    return {

    };
  },
  methods: {
    notices(args) {
      this.$emit('notice', args.item.eventType);
    }
  }
};
</script>
